import { render } from "./MyCommitmentsLayout.vue?vue&type=template&id=0874d2e2&scoped=true"
import script from "./MyCommitmentsLayout.vue?vue&type=script&lang=js"
export * from "./MyCommitmentsLayout.vue?vue&type=script&lang=js"

import "./MyCommitmentsLayout.vue?vue&type=style&index=0&id=0874d2e2&lang=scss"
import "./MyCommitmentsLayout.vue?vue&type=style&index=1&id=0874d2e2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0874d2e2"

export default script